import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { addDays } from 'date-fns';
import { useContext, useMemo } from 'react';
import context from './context';
export default function Columns({ children }) {
    const { startDate, days } = useContext(context);
    const daysOfWeek = useMemo(() => (Array.from(new Array(days), (v, i) => i)), [days]);
    return (_jsx(_Fragment, { children: daysOfWeek.map((i) => {
            return children({
                date: addDays(startDate, i),
                key: i.toString(),
            });
        }) }));
}
